import { render } from "./SimulatedUserCompanySettings.vue?vue&type=template&id=2b945c3c&ts=true"
import script from "./SimulatedUserCompanySettings.vue?vue&type=script&lang=ts"
export * from "./SimulatedUserCompanySettings.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__